import React from 'react';
import PropTypes from 'prop-types';
import { dateCardFormat } from '../../utils';

const Card = ({ link, title, fullDate }) =>
  <li className="box">
    <a
      className="box-link-wrapper"
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      title={title}
    >
      <article className="box-article">
        <div className="box-inner-wrapper">
          <time className="box-date">{dateCardFormat(fullDate)}</time>
          <h1 className="box-title">{title}</h1>
          <span className="box-link">
            Read more <i className="icon icon-budicon-461" aria-hidden="true" />
          </span>
        </div>
      </article>
    </a>
  </li>;

Card.propTypes = {
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  fullDate: PropTypes.string.isRequired
};

export default Card;



// WEBPACK FOOTER //
// ./src/pages/press/components/Card/Card.js